import React, { useCallback } from "react";

type CopyToBuffer = {
  selectContent: VoidFunction;
  copyContentToBuffer: VoidFunction;
};

export const useCopyToBuffer = (
  input: React.RefObject<HTMLInputElement | HTMLTextAreaElement>,
  disabled?: boolean,
): CopyToBuffer => {
  const selectContent = useCallback(() => {
    if (!input.current || disabled) return;

    // handle iOS as a special case
    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      const editable = input.current.contentEditable;
      const { readOnly } = input.current;

      input.current.contentEditable = "true";
      input.current.readOnly = true;

      const range = document.createRange();

      range.selectNodeContents(input.current);

      const selection = window.getSelection();

      selection.removeAllRanges();
      selection.addRange(range);
      input.current.setSelectionRange(0, 999999);
      input.current.contentEditable = editable;
      input.current.readOnly = readOnly;
    } else {
      input.current.select();
    }
  }, [disabled, input]);

  const copyContentToBuffer = useCallback(() => {
    selectContent();

    document.execCommand("copy");
  }, [selectContent]);

  return {
    selectContent,
    copyContentToBuffer,
  };
};
